import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  TGetRecipeAvailabilities,
  TRecipeAvailability,
  TSummaryAvailabilityRecipe,
} from '@mindfulchefuk/types/recipeAvailabilities'
import { fetcherGetRecipeAvailabilities } from '@mindfulchefuk/hooks/useGetRecipeAvailabilities/fetcherGetRecipeAvailabilities'

export const useGetRecipeAvailabilities = ({
  deliveryDate,
  portionCount,
  mealPlan,
}: TGetRecipeAvailabilities): UseQueryResult<
  TRecipeAvailability<TSummaryAvailabilityRecipe>[]
> =>
  useQuery({
    queryKey: [
      'recipe_availabilities',
      { deliveryDate, portionCount, mealPlan },
    ],
    queryFn: fetcherGetRecipeAvailabilities,
    cacheTime: 900000, // 15 minutes
  })
